import { useTranslation } from 'react-i18next'

import { LandingDemoModalTrigger } from '@/features/demos/LandingDemoModalTrigger'

import { WhoItsForSection } from './WhoItsForSection'
import { ASSETS, FOOD_COST_LANDING_PAGE } from './constants'

export function WhatIsTipiSection() {
    const { t } = useTranslation()
    return (
        <section className='bg-[#F5EEE4] py-12 md:py-20' aria-labelledby='what-is-tipi-heading'>
            <div className='mx-auto max-w-[1180px] px-[22px] md:px-10'>
                <div className='grid grid-cols-1 items-center gap-6 md:grid-cols-[minmax(0,1.15fr)_minmax(240px,0.85fr)] md:gap-12 lg:gap-16'>
                    <div className='flex flex-col gap-4 md:gap-5'>
                        <div className='flex items-center gap-3 md:gap-4'>
                            <img
                                src={ASSETS.whatIsTipiCharacter}
                                alt=''
                                width={96}
                                height={104}
                                loading='lazy'
                                decoding='async'
                                className='h-14 w-auto shrink-0 md:hidden'
                                aria-hidden
                            />
                            <h2
                                id='what-is-tipi-heading'
                                className='m-0 text-[28px] font-medium leading-[1.15] tracking-[-0.8px] text-[#F4502A] md:text-[36px] lg:text-[42px]'
                            >
                                {t('foodCost.whatIsTipi.title')}
                            </h2>
                        </div>
                        <p className='m-0 max-w-[52ch] text-[15px] leading-[1.65] text-[#5C5548] md:text-[17px] md:leading-[1.7]'>
                            {t('foodCost.whatIsTipi.body')} {t('foodCost.whatIsTipi.bodyForWhom')}
                        </p>
                        <LandingDemoModalTrigger
                            demoId='product-tour'
                            landingPage={FOOD_COST_LANDING_PAGE}
                            trackEvent='What Is Tipi Product Tour'
                            ctaLabel={t('foodCost.whatIsTipi.watchDemo')}
                            title={t('foodCost.whatIsTipi.productTourTitle')}
                            closeLabel={t('foodCost.whatIsTipi.productTourClose')}
                            dialogClassName='md:w-[min(calc(100%-3rem),920px)]'
                        />
                    </div>
                    <img
                        src={ASSETS.whatIsTipiCharacter}
                        alt=''
                        width={424}
                        height={512}
                        loading='lazy'
                        decoding='async'
                        className='mx-auto hidden h-auto w-full max-w-[240px] md:block lg:max-w-[280px]'
                        aria-hidden
                    />
                </div>
            </div>

            <WhoItsForSection />
        </section>
    )
}
